import script from "./ExamStart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExamStart.vue?vue&type=script&lang=ts&setup=true"

import "./ExamStart.vue?vue&type=style&index=0&id=c2062a70&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2062a70"]])

export default __exports__